import { FC } from 'react'

import { IconRocket } from '@sequencehq/core-components'

import { NodeIconTemplate } from 'Automations/nodeDefinitions/components'
import { IconProps } from '../../types'

export const ActionIcon: FC<IconProps> = ({ boxSize, theme = 'purple' }) => {
  return (
    <NodeIconTemplate icon={<IconRocket />} theme={theme} boxSize={boxSize} />
  )
}
